module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Note10+ Aura White.7c3a5fc0.png";